const PrintConfiguration = () => {
  return <div>PrintConfiguration</div>;
};

export default PrintConfiguration;
